import React, { useEffect, useState, useContext } from "react";
import "./VoyahExteriorInterior.css";

import exterior1 from "../../../../assets/images/voyahfree/exterior/ex1.webp";
import exterior2 from "../../../../assets/images/voyahfree/exterior/ex2.webp";
import exterior3 from "../../../../assets/images/voyahfree/exterior/ex3.webp";
import exterior4 from "../../../../assets/images/voyahfree/exterior/ex4.webp";

import interior1 from "../../../../assets/images/voyahfree/interior/int1.webp";
import interior2 from "../../../../assets/images/voyahfree/interior/int2.webp";
import interior3 from "../../../../assets/images/voyahfree/interior/int3.webp";
import interior4 from "../../../../assets/images/voyahfree/interior/int4.webp";
import interior5 from "../../../../assets/images/voyahfree/interior/int5.webp";
import interior6 from "../../../../assets/images/voyahfree/interior/int6.webp";

import accessories1 from "../../../../assets/images/voyahfree/interior/int1.webp";
import accessories2 from "../../../../assets/images/voyahfree/interior/int2.webp";

import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";

const EXTERIOR_IMAGES = [exterior1, exterior2, exterior3, exterior4];
const INTERIOR_IMAGES = [
  interior1,
  interior2,
  interior3,
  interior4,
  interior5,
  interior6,
];
const ACCESSORIES_IMAGES = [accessories1, accessories2];

const VoyahSlider = ({ title, images }) => {
  const [index, setIndex] = useState(0);

  if (!images || images.length === 0) return null;

  const prev = () =>
    setIndex(index === 0 ? images.length - 1 : index - 1);

  const next = () =>
    setIndex(index === images.length - 1 ? 0 : index + 1);

  return (
    <section dir="ltr" className="voyah-gallery-section">
      <h2 className="voyah-gallery-title">{title}</h2>
      <span className="voyah-gallery-line" />

      <div className="voyah-slider">
        <img src={images[index]} alt={title} className="voyah-slide-image" />

        <button className="voyah-arrow voyah-arrow-left" onClick={prev}>
          ‹
        </button>

        <button className="voyah-arrow voyah-arrow-right" onClick={next}>
          ›
        </button>

        <div className="voyah-dots">
          {images.map((_, i) => (
            <span
              key={i}
              className={`voyah-dot ${i === index ? "active" : ""}`}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

const VoyahExteriorInterior = () => {
  const { currentLang } = useContext(LanguageContext);

  const [titles, setTitles] = useState({
    exterior_title: "Exterior",
    interior_title: "Interior",
    accessories_title: "Accessories",
  });

  useEffect(() => {
    const loadGalleryText = async () => {
      try {
        const response = await getPageContent("voyahfree", currentLang);
        const gallery = response.sections?.gallery;

        if (gallery) {
          setTitles({
            exterior_title: gallery.exterior_title || "Exterior",
            interior_title: gallery.interior_title || "Interior",
            accessories_title: gallery.accessories_title || "Accessories",
          });
        }
      } catch (err) {
        console.error("Failed to load Voyah Free gallery text", err);
      }
    };

    loadGalleryText();
  }, [currentLang]);

  return (
    <div className="voyah-gallery-wrapper">
      <VoyahSlider title={titles.exterior_title} images={EXTERIOR_IMAGES} />
      <VoyahSlider title={titles.interior_title} images={INTERIOR_IMAGES} />
      <VoyahSlider
        title={titles.accessories_title}
        images={ACCESSORIES_IMAGES}
      />
    </div>
  );
};

export default VoyahExteriorInterior;
